import * as Sentry from '@sentry/react'

let initialized = false

function sanitizeValue(value: string): string {
  return value
    .replaceAll(/sk-[a-zA-Z0-9_-]{20,}/g, '[REDACTED_API_KEY]')
    .replaceAll(/pk-[a-zA-Z0-9_-]{20,}/g, '[REDACTED_API_KEY]')
}

export function initSentry(): void {
  if (initialized) return
  if (import.meta.env.DEV) return

  const dsn = import.meta.env.VITE_SENTRY_DSN
  if (!dsn) {
    console.warn('VITE_SENTRY_DSN not set, Sentry disabled')
    return
  }

  // Route through our control-plane tunnel to bypass ad blockers
  const apiUrl = import.meta.env.VITE_API_URL
  const tunnel = apiUrl ? `${apiUrl}/t` : undefined

  Sentry.init({
    dsn,
    tunnel,
    environment: import.meta.env.MODE,
    release: import.meta.env.VITE_APP_VERSION || '2.0.1',
    tracesSampleRate: 0.1,
    beforeSend(event) {
      if (event.message) {
        event.message = sanitizeValue(event.message)
      }
      if (event.exception?.values) {
        for (const ex of event.exception.values) {
          if (ex.value) ex.value = sanitizeValue(ex.value)
        }
      }
      return event
    },
  })

  initialized = true
}
